import React from 'react';
import PropTypes from 'prop-types';
import { padDate } from '../../../store/storeFunctions';
import { hasPermission } from "../../../store/apiWrapper";

import CribisLogoSk from '../../../img/Cribis.sk';
import CribisLogoCz from '../../../img/Cribis.cz';
import CribisLogoSkImg from '../../../img/Cribis.sk.png';
import CribisLogoCzImg from '../../../img/Cribis.cz.png';

class ChartDiagramExportTemplate extends React.Component {
    static propTypes = {
        agentLanguage: PropTypes.string.isRequired,
        width: PropTypes.number.isRequired,
        height: PropTypes.number.isRequired,
        diagramImage: PropTypes.object.isRequired,
        translations: PropTypes.object.isRequired,
        showDisclaimer: PropTypes.bool,
        forceImg: PropTypes.bool,
        disclaimerWidth: PropTypes.number,
        wrapperWidth: PropTypes.number.isRequired,
        wrapperHeight: PropTypes.number.isRequired,
        username: PropTypes.string,
        hasDeletedParts: PropTypes.bool
    };

    static defaultProps = {
        showDisclaimer: true,
        forceImg: false,
        disclaimerWidth: 1150,
        hasDeletedParts: false
    };

    render() {
        const now = new Date();
        const disclaimer = this.props.agentLanguage === 'sk-SK' ? this.props.translations.disclaimerSk : this.props.translations.disclaimerCz;
        const disclaimerRows = disclaimer.split('&lt;br /&gt;');

        return (
            <div style={{ minWidth: `${this.props.wrapperWidth}px`, minHeight: `${this.props.wrapperHeight}px`, width: `${this.props.wrapperWidth}px`, height: `${this.props.wrapperHeight}px`, marginBottom: "15px" }}>
                <div style={{ float: "left", padding: "5px 0 0 5px" }}>
                    {this.getLogo(this.props.agentLanguage, this.props.forceImg)}
                </div>
                <div style={{ float: "right", padding: "5px 5px 0 0" }}>
                    <div>
                        <span style={{ fontWeight: "bold" }}>{this.props.translations["reportDate"]}:</span>{' '}
                        <span>{`${padDate(now.getDate())}.${padDate(now.getMonth() + 1)}.${now.getFullYear()}`}</span>
                    </div>
                    {!hasPermission(null, "UsernameInvisibility") &&
                        <div>
                            <span style={{ fontWeight: "bold" }}>{this.props.translations["username"]}:</span>{' '}
                            <span>{this.props.username}</span>
                        </div>
                    }
                    {this.props.hasDeletedParts &&
                        <div>
                            <span style={{ fontWeight: "bold" }}>{this.props.translations["removedSubjects"]}:</span>{' '}
                            <span>{this.props.translations["yes"]}</span>
                        </div>
                    }
                </div>
                <div style={{ padding: "5px", boxSizing: "border-box" }}>
                    <img src={this.props.diagramImage.src} width={this.props.width} height={this.props.height} />
                </div>
                {this.props.showDisclaimer && <div style={{ fontSize: "8px", color: "#003A79", width: "100%", marginLeft: "10px" }}>
                    <div style={{ width: `${this.props.disclaimerWidth}px`, margin: "0 auto" }}>
                        <strong>
                            <hr />
                            <p>{disclaimerRows.map((d, i) => <span key={i}>{d}<br /></span>)}</p>
                        </strong>
                    </div>
                </div>}
            </div>
        )
    }

    getLogo = (agentLang, forceImg) => {
        const width = 190;
        const height = 50;
        if (agentLang === 'sk-SK')
            return forceImg ? <img src={CribisLogoSkImg} width={width} height={50} /> : <CribisLogoSk height={`${height}px`} width={`${width}px`} />;
        else
            return forceImg ? <img src={CribisLogoCzImg} width={width} height={50} /> : <CribisLogoCz height={`${height}px`} width={`${width}px`} />;
    }
}

export default ChartDiagramExportTemplate;